//loader
export default function WebbSpinner() {
 
  return (
  <>
    {/* spinner */}
    <div className="spinner-border  spinner-border-sm text-color-tone" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </>
  )
}